import { getHelpDeskChatUrl } from "../utils/helpDeskChat";

/**
 * Floating "chat with our help desk" button. The link itself is built by
 * getHelpDeskChatUrl, shared with the TopBar help icon.
 *
 * With no number configured the button renders nothing, so an environment that
 * has not been set up shows no dead control.
 */
const WhatsAppSupportButton = () => {
  const chatUrl = getHelpDeskChatUrl();

  if (!chatUrl) {
    return null;
  }

  return (
    <a
      href={chatUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with our help desk on WhatsApp"
      // Below MUI's modal layer (1300) so it never floats over an open dialog.
      // pointer-events-none on the row keeps the space the hidden label occupies
      // from sitting over the page as an invisible click-blocking strip; the two
      // children opt back in. Hovering a child still marks the row :hover, so
      // group-hover works and clicks still reach the link.
      className="group pointer-events-none fixed bottom-6 right-6 z-[1200] flex items-center gap-3 focus:outline-none"
    >
      <span className="pointer-events-none translate-x-2 rounded-full bg-white px-4 py-2 text-sm font-medium text-dark opacity-0 shadow-md transition-all duration-200 group-hover:translate-x-0 group-hover:opacity-100 group-focus-within:translate-x-0 group-focus-within:opacity-100">
        Need help?
      </span>

      {/* The ring lives here rather than on the anchor: the anchor's box spans
          the hidden label too, so a ring on it would outline empty space. */}
      <span className="pointer-events-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary shadow-lg ring-primary ring-offset-2 transition-transform duration-200 group-hover:scale-110 group-focus-within:ring-2">
        {/* Phone handset. Inlined rather than a Font Awesome class so the icon
            does not depend on which Font Awesome subset the app happens to
            load. Stroked rather than filled, so it stays legible at this size. */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-7 w-7"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92Z" />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppSupportButton;
